import { sizes } from "../utils";
import type { MontaSVGProps } from "../types";
const ArrowUpDown = ({
  size = "medium",
  color = "inherit",
  ...props
}: MontaSVGProps) => {
  const computedSize = sizes[size] || size;
  props.style = {
    ...props.style,
    color
  };
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 20 20"
      width={computedSize}
      height={computedSize}
      {...props}
    >
      <path
        fill="#475467"
        d="M8.71 6.225a.62.62 0 0 1-.442-.183L5.61 3.383 2.95 6.042a.63.63 0 0 1-.883 0 .63.63 0 0 1 0-.884l3.1-3.1a.624.624 0 0 1 .883 0l3.1 3.1a.63.63 0 0 1 0 .884.62.62 0 0 1-.441.183"
      />
      <path
        fill="#475467"
        d="M5.61 18.125a.63.63 0 0 1-.626-.625v-15a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v15a.63.63 0 0 1-.625.625M14.399 18.125a.63.63 0 0 1-.442-.183l-3.1-3.1a.63.63 0 0 1 0-.883.63.63 0 0 1 .883 0l2.659 2.658 2.658-2.658a.63.63 0 0 1 .883 0 .63.63 0 0 1 0 .883l-3.1 3.1a.64.64 0 0 1-.441.183"
      />
      <path
        fill="#475467"
        d="M14.39 18.125a.63.63 0 0 1-.624-.625v-15a.63.63 0 0 1 .625-.625.63.63 0 0 1 .625.625v15a.624.624 0 0 1-.625.625"
      />
    </svg>
  );
};
export default ArrowUpDown;
